module.exports = __webpack_public_path__ + "img/5.895eb64e.jpg";